import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { KpisComponent } from './kpis.component';
import { JobStatusTotalsComponent } from './charts/job-status-totals/job-status-totals.component';
import { LeadTypeBreakdownComponent } from './charts/lead-type-breakdown/lead-type-breakdown.component';
import { SharedModule } from '@shared/shared.module';
@NgModule({
  declarations: [
    KpisComponent,
    JobStatusTotalsComponent,
    LeadTypeBreakdownComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
  ],
  providers: [
    DecimalPipe
  ],
  exports: [
    KpisComponent,
    JobStatusTotalsComponent,
    LeadTypeBreakdownComponent
  ]
})
export class KpisModule { } 